export const CACHE_KEY_DETAILED_RETAINER_EXPENSE_BY_CONTRACT_ID =
  "detailed-retainer-expense-by-contract-id";
export const CACHE_KEY_RECURRING_SERVICES_CONTRACT_DETAIL_BY_CONTRACT_ID =
  "recurring-services-contract-detail-by-contract-id";
export const retainerBurndownStyles = {
  position: "relative",
  height: "450px",
  width: "100%",
};
